module.exports = __webpack_public_path__ + "img/ico-print.f5a1731f.svg";